import React from 'react';
import { STUDENTS_VIEW, NavigationView } from './constants';
import { Chip, Box } from '@ublend-npm/aulaui-core';

const navItems: { key: NavigationView; label: string }[] = [
  {
    key: STUDENTS_VIEW,
    label: 'Students',
  },
];

type NavigationProps = {
  onChange?: (view: NavigationView) => void;
  selected: NavigationView;
};

const Navigation = ({ onChange = () => {}, selected }: NavigationProps) => {
  return (
    <Box sx={{ mt: '0.25rem' }}>
      {navItems?.map(({ key, label }) => {
        const isSelected = selected === key;

        return (
          <Box key={key}>
            <Chip
              id={key}
              kind="primary"
              aria-pressed={isSelected}
              isSelected={isSelected}
              onClick={() => !isSelected && onChange(key)}
              label={label}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default React.memo(Navigation);
